import { render, staticRenderFns } from "./Elevator.vue?vue&type=template&id=69dc05e6&scoped=true&"
import script from "./Elevator.vue?vue&type=script&lang=js&"
export * from "./Elevator.vue?vue&type=script&lang=js&"
import style0 from "./Elevator.vue?vue&type=style&index=0&id=69dc05e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dc05e6",
  null
  
)

export default component.exports